import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=20c5944c&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=20c5944c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c5944c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20c5944c')) {
      api.createRecord('20c5944c', component.options)
    } else {
      api.reload('20c5944c', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=20c5944c&scoped=true&", function () {
      api.rerender('20c5944c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2EhEEoaFEE9US/JS/teamMember.vue"
export default component.exports